module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_is-object.js
// module id = 131
// module chunks = 0